import { Action, ActionReducer } from "@ngrx/store";
import {
  iAcuerdo,
  iCatalogos,
  iComentarios,
  iFormasEnvio,
  iEntrada,
  iEntregables,
  mCatalogos,
  mEntrada,
  miComentarios,
  mAcuerdo,
  miFormasEnvio,
} from "./entrada/entrada.interface";
import {
  IAcuerdoSeleccionado,
  IAcuerdos,
  SIAcuerdoSeleccionado,
  SIAcuerdos,
} from "./interfaces/acuerdos";
import { acuerdoReducer } from "./states/acuerdo/reducers";
import { acuerdosMrbReducer } from "./states/acuerdos-mrb/reducers";
import { iUsuario, mUsuario } from "./usuario/usuario.interface";
import { catalogoReducer } from "./states/catalogos/reducers";
import { entradaReducer } from "./states/entrada/reducers";
import { comentariosReducer } from "./states/comentarios/reducers";
import { usuarioReducer } from "./states/usuario/reducers";
import {
  InnitShowHideCatalogos,
  IShowHideCatalogos,
} from "./interfaces/admonCatalogos";
import { IFormaEnvio, initDespachos } from "./interfaces/despacho";
import { IEntradas, IEntradasInitState } from "./interfaces/entradas";
import { IFormState, InitialFormState } from "./interfaces/forms";
import { admonCatalogosReducer } from "./states/admon-catalogos/reducers";
import { formasEnvioReducer } from "./states/formas-envio/reducers";
import { DespachoEffects } from "./states/despacho/effects";
import { despachosReducer } from "./states/despacho/reducers";
import { entradasReducer } from "./states/entradas/reducers";
import { AcuerdoEffects } from "./states/forms/effects";
import { validateFormReducer } from "./states/forms/reducers";
import { acuerdoSeleccionadoReducer } from "./states/temas/reducers";
import { entregablesReducer } from "./states/entregables/reducers";
import { IBusquedaInitState, IBusquedaState } from "./interfaces/busqueda";
import { busquedaReducer } from "./states/busqueda/reducers";
import { BusquedaEffects } from "./states/busqueda/efects";
import { CatalogosEffects } from "./states/catalogos/efects";
import { AcuerdosEffects } from "./states/acuerdos-mrb/efects";
import { EntradasEffects } from "./states/entradas/effects";
import { TemasEffects } from "./states/temas/effects";

export interface AppState {
  catalogos: iCatalogos;
  entrada: iEntrada;
  comentarios: iComentarios[];
  usuario: iUsuario;
  acuerdo: iAcuerdo;
  acuerdosMRB: IAcuerdos;
  acuerdoSeleccionado: IAcuerdoSeleccionado;
  entradas: IEntradas;
  validateForm: IFormState;
  admonCatalogos: IShowHideCatalogos;
  formasEnvio: iFormasEnvio[];
  formaEnvio: IFormaEnvio;
  entregables: iEntregables[];
  busqueda: IBusquedaState;
}

export interface AppStore {
  catalogos: ActionReducer<iCatalogos, Action>;
  entrada: ActionReducer<iEntrada, Action>;
  comentarios: ActionReducer<iComentarios[], Action>;
  usuario: ActionReducer<iUsuario, Action>;
  acuerdo: ActionReducer<iAcuerdo, Action>;
  acuerdosMRB: ActionReducer<IAcuerdos, Action>;
  acuerdoSeleccionado: ActionReducer<IAcuerdoSeleccionado, Action>;
  entradas: ActionReducer<IEntradas, Action>;
  validateForm: ActionReducer<IFormState, Action>;
  admonCatalogos: ActionReducer<IShowHideCatalogos, Action>;
  formasEnvio: ActionReducer<iFormasEnvio[], Action>;
  formaEnvio: ActionReducer<IFormaEnvio, Action>;
  entregables: ActionReducer<iEntregables[], Action>;
  busqueda: ActionReducer<IBusquedaState, Action>;
}

export const appStore: AppStore = {
  catalogos: catalogoReducer,
  entrada: entradaReducer,
  comentarios: comentariosReducer,
  usuario: usuarioReducer,
  acuerdo: acuerdoReducer,
  acuerdosMRB: acuerdosMrbReducer,
  acuerdoSeleccionado: acuerdoSeleccionadoReducer,
  entradas: entradasReducer,
  validateForm: validateFormReducer,
  admonCatalogos: admonCatalogosReducer,
  formasEnvio: formasEnvioReducer,
  formaEnvio: despachosReducer,
  entregables: entregablesReducer,
  busqueda: busquedaReducer,
};

export const appEffects = [
  AcuerdoEffects,
  DespachoEffects,
  BusquedaEffects,
  CatalogosEffects,
  AcuerdosEffects,
  EntradasEffects,
  TemasEffects,
];
//https://dev.to/codecraftjs/step-by-step-guide-for-ngrx-with-angular-16-30jd

export const resetAppState: AppState = {
  catalogos: mCatalogos,
  entrada: mEntrada,
  comentarios: [miComentarios],
  usuario: mUsuario,
  acuerdo: mAcuerdo,
  acuerdosMRB: SIAcuerdos,
  acuerdoSeleccionado: SIAcuerdoSeleccionado,
  entradas: IEntradasInitState,
  validateForm: InitialFormState,
  admonCatalogos: InnitShowHideCatalogos,
  formasEnvio: [],
  formaEnvio: initDespachos,
  entregables: [],
  busqueda: IBusquedaInitState,
};
